import * as React from 'react';

import {dayjs} from '../../utils/datetime';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers'
import { useFormContext } from 'react-hook-form';
import { Controller } from "react-hook-form"

const FormDateTimePicker = ({ name, label, required, rules = {}, shrinkLabel = undefined, ...props }) => {

  const { control } = useFormContext();

  const requiredDefaultRule = required ? { required: { value: true, message: "This field is required" } } : {};
  rules = { ...requiredDefaultRule, ...rules };

  console.log("FormDateTimePicker", name)

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        render={({ field: { onChange, value } }) => {

          return <DateTimePicker
            label={label}
            value={value}
            onChange={(newValue) => { 
				onChange(dayjs(newValue)) 
			}}
			sx={{width: '100%'}}
            {...props}
          />
        }
        }
        name={name}
        control={control}
        rules={rules}
      />
    </LocalizationProvider>
  );
};
export default FormDateTimePicker;
